// The affiliate program (Marketing section) is in limited beta. Only these
// companies see the surface: the sidebar nav item and the /marketing routes.
// To roll out to everyone, widen or remove this allowlist (single source of
// truth — don't hardcode the ids elsewhere).
export const AFFILIATES_BETA_COMPANY_IDS = [5, 7];

/**
 * True when the signed-in company is in the affiliates beta. Reads the company
 * id from localStorage (same key the rest of the app uses). Defaults to false
 * on any parse issue so the feature stays hidden by default.
 */
export function isAffiliatesBetaCompany() {
  try {
    const id = Number(localStorage.getItem('companyId'));
    return AFFILIATES_BETA_COMPANY_IDS.includes(id);
  } catch (e) {
    return false;
  }
}
